import { inject, bindable } from 'aurelia';
import { ICustomElementController } from '@aurelia/runtime-html';
import { IRouter } from '@aurelia/router-lite';

import { getAWSBucketEndpoint, websiteShortCode, environment } from '../../../../environment';
import { Helper } from '../../../extensions';

import './ds-posts-cards.scss';

@inject(Helper, IRouter)
export class DsPostsCards {
    constructor(
        private helper: Helper,
        private router: IRouter,
    ) {
        this.baseAwsEndpoint = getAWSBucketEndpoint('blog');
    }

    @bindable blogs;
    @bindable blogRoute;
    baseAwsEndpoint: string | undefined;
    public readonly $controller: ICustomElementController<this>;
    parent;
    shortCode: string = websiteShortCode() ?? 'CG';

    blogsChanged() {
        this.blogs?.forEach(blog => {
            blog.content = blog.content?.replace(/(<([^>]+)>)/gi, '');
        });
    }

    binding() {
        const scope = this.$controller.scope;
        this.parent = scope.parent?.bindingContext;
    }

    // Reference: Alternative to the parent Context approach. We spammed this in au1, review.
    async tagClickHandler(tag) {
        await this.parent.tagClickHandler({
            name: tag.target.textContent.replace(' ', '').trim(),
            slug: tag.target.textContent.trim().replace('&', 'and').replace(/ /g, '-').toLowerCase(),
            activate: true
        });
    }

    navigateToBlog(slug: string, event: Event) {
        event.preventDefault();
        const route = this.helper.languageRoute(slug);
        if (!route) {
            return;
        }

        void this.router.load(route.startsWith('/') ? route : `/${route}`);
    }

    navigateToAuthor(alias: string, event: Event) {
        event.preventDefault();
        const route = this.helper.languageRoute(`author/${alias.toLowerCase()}`);
        if (!route) {
            return;
        }

        void this.router.load(route.startsWith('/') ? route : `/${route}`);
    }

    get bannerImageByWebsite() {
        const isResources = window.location.hostname.includes('resources');
        const basePath = isResources || environment() === 'local' ? '' : '/blog';

        const logos = {
            CG: 'logo/logo-cg.svg',
            CX: 'logo/logo-cx.svg',
            DS: 'logo/ds-logo-dark.svg',
            GT: 'logo/gt-logo-dark.svg'
        };

        return logos[this.shortCode]
            ? `${basePath}/${logos[this.shortCode]}`
            : 'UNDEFINED';
    }

    isCsrBlog = (blog) => {
        if (blog?.blogTags?.length) {
            return blog?.blogTags?.some(tag => tag?.blogTag?.name?.toLowerCase() === 'csr');
        }
        return false;
    };
}
